import { Outlet } from 'react-router-dom';
import Sidebar from '../Components/Sidebar';
import MobileBottomNav from '../Components/MobileBottomNav';
import useSidebarCollapsed from '../hooks/useSidebarCollapsed';

const AdminLayout = () => {
  const [isCollapsed, setIsCollapsed] = useSidebarCollapsed();

  return (
    <div className='container-fluid px-md-4'>
      <div className='row g-4 pt-4'>
        <div className='col-auto d-none d-lg-block'>
          <Sidebar
            isCollapsed={isCollapsed}
            toggleSidebar={() => setIsCollapsed(!isCollapsed)}
          />
        </div>
        <div className='col py-2 overflow-hidden pb-5 pb-lg-2'>
          <Outlet />
        </div>
      </div>
      <MobileBottomNav />
    </div>
  );
};

export default AdminLayout;
